import { useEffect } from "react";

const BASE = "https://vcclaychurch.com";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, path = "/", jsonLd, image }) {
  useEffect(() => {
    const full = title ? `${title} | Victory Chapel Clay` : "Victory Chapel Clay | A New Church in Clay County, Florida";
    document.title = full;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", full);
    setMeta("property", "og:site_name", "Victory Chapel Clay");
    setMeta("property", "og:url", `${BASE}${path}`);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", image ? `${BASE}${image}` : `${BASE}/you-belong-here.jpg`);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${BASE}${path}`);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, jsonLd, image]);
  return null;
}
